let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1DcfU"), load("2Yc7I")]).then(() => parcelRequire('4elbo'));